export default "__VITE_ASSET__CWdM$qrQ__"